<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_product.edit') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="product.client_id" item-value="id" item-text="name" :items="clients" :label="$t('edit_product.client')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                       <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.sku" :label="$t('edit_product.sku')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.barcode" :label="$t('edit_product.barcode')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.description" :label="$t('edit_product.description')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="product.category_id" item-value="id" item-text="name"  :items="categories" :label="$t('edit_product.category')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.storage_policy" :label="$t('edit_product.refill_alert')" :rules="numeric_required"></v-text-field>
                            </v-col>
                        </v-row>      
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="product.unit" :items="units" :label="$t('edit_product.unit')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="product.size_unit" :items="size_units" :label="$t('edit_product.size_unit')"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.height" :label="$t('edit_product.height')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.length" :label="$t('create_product.length')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.width" :label="$t('create_product.width')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="product.weight" :label="$t('edit_product.weight')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 pb-2 my-0" justify="center" align="center">
                            <v-col cols="4" class="px-3 py-0">
                                <span >{{ $t('edit_product.product_national') }}:</span>
                            </v-col>
                            <v-col cols="2" class="px-3 py-0" justify="end" align="end">
                                <v-btn class="radio-left white--text" v-bind:color="product.is_national == false ? 'blue_accent' : 'grey'" @click="product.is_national = false">{{ $t('edit_product.no') }}</v-btn>
                                <v-btn class="radio-right white--text" v-bind:color="product.is_national == true? 'blue_accent' : 'grey'" @click="product.is_national = true">{{ $t('edit_product.yes') }}</v-btn>
                            </v-col>
                        </v-row>

                        <br v-if="!client_hd">
                        
                        <v-row class="px-5 pb-2 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="6" class="px-3 py-0" justify="center" align="center">
                                <span >{{ $t('edit_product.product_image') }}</span>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-avatar
                                size="200"
                                class="cursor-pointer rounded-lg"
                                color="background"
                                @click="triggerFileInput"
                                >
                                <img :src="product.image || default_image"/>
                            </v-avatar>
                            <input
                                type="file"
                                ref="fileInput"
                                accept="image/*"
                                class="d-none"
                                @change="onFileChange"
                            />
                        </v-row>
                        <br  v-if="!client_hd">

                    </v-form>
                    <v-row class="px-5 py-0 mt-2" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-row class="px-3">
                                <v-btn class="right px-3 mx-0 white_highlight--text" color="red" @click="checkCanDelete()">
                                    {{ $t('edit_product.modal.delete') }}
                                </v-btn>

                                <v-spacer></v-spacer>

                                <v-btn class="right px-3 mx-4" @click="cancel">
                                    {{ $t('edit_product.cancel') }}
                                </v-btn>
                                <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'product.update'">
                                    {{ $t('edit_product.save') }}
                                </v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>       
        <v-dialog v-model="modalDelete" persistent max-width="90%">
            <v-card >
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('edit_product.modal.delete') }}
                            </h3>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                        <v-col cols="12">
                            <h5>{{ $t('edit_product.modal.' + message) }}</h5>
                        </v-col>
                    </v-row>
                    
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn class="mx-3" text @click="modalDelete = false" v-if="message != 'product_with_stock'">{{ $t('edit_product.no') }}</v-btn>
                        <v-btn color="error" @click="deleteProduct" v-permission="'product.delete'" v-if="message != 'product_with_stock'"> {{ $t('edit_product.yes') }} </v-btn>
                        <v-btn @click="modalDelete = false" v-if="message == 'product_with_stock'"> {{ $t('edit_product.cancel') }} </v-btn>
                    </div>
                </v-card-text> 
                <div class="marker"></div>
            </v-card>
        </v-dialog> 
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { showProductUseCase } from "../../contexts/products/application/use_cases/show_product_use_case";
import { HttpProductRepository } from "../../contexts/products/infrastructure/product_repository";
import { customerIndexUseCase } from "../../contexts/customers/application/use_cases/customer_index_use_case";
import { HttpCustomerRepository } from "../../contexts/customers/infrastructure/customer_repository";
import { categoriesIndexUseCase } from '../../contexts/categories/application/use_cases/categories_index_use_case'
import { HttpCategoryRepository } from '../../contexts/categories/infrastructure/category_repository'

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        numeric_required(){
            return [
                v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                v => !!v || this.$t('edit_appointment.validations.required_field')
            ];
        },
    },
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            message: '',
            modalDelete: false,
            product: {
                sku: '',
                description: '',
                storage_policy: 0,
                quantity: '',
                cost: '',
                unit: '',
                weight: '',
                is_national: true,
                client_id: '',
                category_id: '',
                barcode: '', 
                height: '', 
                length : '', 
                width: '',
                size_unit: '',
                image: null
            },
            default_image: localStorage.getItem('language') == "en" ? '/img/default-product_en.png' : '/img/default-product_es.jpg',
            file: [],
            categories: [],
            clients: [],
            size_units: ["CM/KG", "IN/LB"],
            units: [
                "KILO",
                "GRAMO",
                "METRO LINEAL",
                "METRO CUADRADO",
                "METRO CÚBICO",
                "PIEZA",
                "CABEZA",
                "LITRO",
                "PAR",
                "KILOWATT",
                "MILLAR",
                "JUEGO",
                "KILOWATT/HORA",
                "TONELADA",
                "BARRIL",
                "GRAMO NETO",
                "DECENAS",
                "CIENTOS",
                "DOCENAS",
                "CAJA",
                "BOTELLA",
                "POUNDS",
                "FEET"
            ],
            client_hd: false,
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.edit_product";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.clients = [];

                const res = await customerIndexUseCase(2, 1, this.$store.state.page_size, "", [], HttpCustomerRepository);
                this.clients = res.data;

                this.clients.forEach(x => {
                    if(x.client_type == "HD") x.name = x.name + " (" + this.$t("create_product.client_hd") + ")";
                })

                this.categories = [];
                const res_categories = await categoriesIndexUseCase(1, this.$store.state.page_size, "", [], HttpCategoryRepository);
                this.categories = res_categories.data;

                const result = await showProductUseCase(this.id, HttpProductRepository);

                this.product = result;
                if(this.product.image != null){
                    this.file = new File(["foo"], this.$t("edit_user.profile_picture"), {
                        type: "text/plain",
                    });
                }

                if(result.client.client_type == "HD") this.client_hd = true;

                this.product.client_id = result.client.id;
                this.product.category_id = result.category.id
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        save(){
            this.$store.state.loaderProps.visible = true;

            const formVal = this.$refs.form.validate();

            if(!formVal){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('create_product.form_invalid')
                }
                this.$store.state.loaderProps.visible = false;

                return;
            }

            const formData = new FormData();

            formData.append("product[sku]", this.product.sku);
            formData.append("product[description]", this.product.description);
            formData.append("product[storage_policy]", this.product.storage_policy);
            formData.append("product[quantity]", this.product.quantity);
            formData.append("product[cost]", this.product.cost);
            formData.append("product[unit]", this.product.unit);
            formData.append("product[weight]", this.product.weight);
            formData.append("product[is_national]", this.product.is_national);
            formData.append("product[client_id]", this.product.client_id);
            formData.append("product[category_id]", this.product.category_id);
            formData.append("product[barcode]", this.product.barcode);
            formData.append("product[height]", this.product.height);
            formData.append("product[length]", this.product.length);
            formData.append("product[width]", this.product.width);
            formData.append("product[size_unit]", this.product.size_unit);
            if(this.file != [] && this.file.type != 'text/plain' && this.file != ""){
                formData.append("product[image]", this.file);
            }

            const lsToken = localStorage.getItem("access_token");
            this.$http.put(this.$store.state.chronosApi + 'products/' + this.id, formData, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status == 200){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('edit_product.responses.success')
                    }
                    this.$router.push({ name: "ProductsIndex" });  
                }
            }).catch((err) => {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: err.response.data.message
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        cancel(){
            this.$router.go(-1);
        },
        deleteProduct(){
            const lsToken = localStorage.getItem("access_token");
            this.$http.delete(this.$store.state.chronosApi + 'products/' + this.id, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status == 200){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('edit_warehouse.responses.success')
                    }
                    this.$router.push({ name: "ProductsIndex" });  
                }
            }).catch((err) => {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: err.response.data.message
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        async checkCanDelete(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");

            const response = await this.$http.get(this.$store.state.chronosApi + 'products/can_delete/' + this.id, {headers: {Authorization: lsToken}});
            this.message = response.data.message;
            this.modalDelete = true;
            this.$store.state.loaderProps.visible = false;
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            this.file = file;

            if (file) {
                this.product.image = URL.createObjectURL(file);
            // Si quieres subirlo, también puedes almacenarlo en FormData aquí.
            }
        },
    },
    watch:{
        'product.client_id': function(){
            this.client_hd = false;
            if(this.clients.find(x => x.id == this.product.client_id).type == "HD") {
                this.client_hd = true;
                this.product.category_id = this.categories.find(x => x.name == "HEAVY DUTY").id;
            }
        }
    }
}
</script>

<style lang="css">
.cursor-pointer {
  cursor: pointer;
}
.d-none {
  display: none;
}
</style>